import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const settingsOfficeReducer = combineReducers({
  searchResult: searchResultReducer,
});

export default settingsOfficeReducer;
